import { render, staticRenderFns } from "./MoveCategoryModal.vue?vue&type=template&id=897da4e6&scoped=true&"
import script from "./MoveCategoryModal.vue?vue&type=script&lang=js&"
export * from "./MoveCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveCategoryModal.vue?vue&type=style&index=0&id=897da4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897da4e6",
  null
  
)

export default component.exports